export const isValidReading = (reading) => {
    let flag = true
    if(!reading?.latitude || !reading?.longitude) flag = false
    return flag
}